import {
  HOME_CLIENT_PENDING_REQUEST_BEGIN,
  HOME_CLIENT_PENDING_REQUEST_SUCCESS,
  HOME_CLIENT_PENDING_REQUEST_FAILURE,
  HOME_CLIENT_PENDING_REQUEST_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';

export function clientPendingRequest(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_CLIENT_PENDING_REQUEST_BEGIN,
    });
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}clients/pending-request`,
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CLIENT_PENDING_REQUEST_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_CLIENT_PENDING_REQUEST_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>clientPendingRequest', err);
        },
      );
    });

    return promise;
  };
}

export function dismissClientPendingRequestError() {
  return {
    type: HOME_CLIENT_PENDING_REQUEST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CLIENT_PENDING_REQUEST_BEGIN:
      return {
        ...state,
        clientPendingRequestPending: true,
        clientPendingRequestError: null,
      };

    case HOME_CLIENT_PENDING_REQUEST_SUCCESS:
      return {
        ...state,
        clientPendingRequestPending: false,
        clientPendingRequestError: null,
        transferRequest: action.data,
      };

    case HOME_CLIENT_PENDING_REQUEST_FAILURE:
      return {
        ...state,
        clientPendingRequestPending: false,
        clientPendingRequestError: action.data.error,
      };

    case HOME_CLIENT_PENDING_REQUEST_DISMISS_ERROR:
      return {
        ...state,
        clientPendingRequestError: null,
      };

    default:
      return state;
  }
}
